import NavPanel from './NavPanel';

export { type NavPanelProps } from './NavPanel';
export default NavPanel;
